import React from "react";
import { makeStyles } from "@material-ui/core";

/**
 * Support-contact card. Shown on checkout + every shipping state so the
 * customer can reach us from anywhere in the flow. WhatsApp + email only.
 */

const WHATSAPP_NUMBER = "918064124248";
const WHATSAPP_DISPLAY = "+91 8064124248";
const EMAIL = "shop@aisensy.com";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    padding: "14px 16px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 10,
    fontFamily: "'Inter', sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },
  heading: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "#6b7280",
  },
  links: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: 14,
  },
  link: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    textDecoration: "none",
    fontSize: 13,
    lineHeight: "18px",
    "&:hover $linkValue": { textDecoration: "underline" },
  },
  linkLabel: {
    color: "#374151",
    fontWeight: 500,
  },
  linkDash: {
    color: "#9ca3af",
  },
  linkValue: {
    color: "#04cf66",
    fontWeight: 600,
  },
  divider: {
    width: 4,
    height: 4,
    borderRadius: "50%",
    backgroundColor: "#d1d5db",
  },
}));

const SupportContact = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.heading}>Need help?</div>
      <div className={classes.links}>
        <a
          className={classes.link}
          href={`https://wa.me/${WHATSAPP_NUMBER}`}
          target="_blank"
          rel="noreferrer noopener"
        >
          <span className={classes.linkLabel}>WhatsApp</span>
          <span className={classes.linkDash}>:</span>
          <span className={classes.linkValue}>{WHATSAPP_DISPLAY}</span>
        </a>
        <span className={classes.divider} aria-hidden="true" />
        <a className={classes.link} href={`mailto:${EMAIL}`}>
          <span className={classes.linkLabel}>Email</span>
          <span className={classes.linkDash}>:</span>
          <span className={classes.linkValue}>{EMAIL}</span>
        </a>
      </div>
    </div>
  );
};

export default SupportContact;
